import React from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import notificationPopUp from '../../../NotificationPopUp';

import ConfirmationModal from '../../common/ConfirmationModal';
import CheckboxInput from '../../common/checkBox/CheckboxInput';
import TextInput from '../../common/TextInput';
import TooltipFormatter from '../../common/TooltipFormatter';

import * as authenticationActions from '../../../actions/authenticationActions';
import * as commonActions from '../../../actions/commonActions';
import * as warrantyActions from '../../../actions/warrantyActions';


class WarrantiesPage extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            authenticationState: this.props.authenticationState,
            commonState: this.props.commonState,
            pagingModel: this.props.pagingModel,
            warrantyDeleteModal: {
                show: false,
                dropRowKeysp: []
            }
        };

        if (!authenticationActions.verifyAuthentication(this.state.authenticationState, this.props.history)) {
            return;
        }

        this.gridActive = this.gridActive.bind(this);
        this.gridCompany = this.gridCompany.bind(this);
        this.gridOnRowClick = this.gridOnRowClick.bind(this);
        this.onPageChange = this.onPageChange.bind(this);
        this.onSortChange = this.onSortChange.bind(this);
        this.redirectToWarrantyPage = this.redirectToWarrantyPage.bind(this);
        this.search = this.search.bind(this);
        this.showHideWarrantyDeleteModal = this.showHideWarrantyDeleteModal.bind(this);
        this.updateFilters = this.updateFilters.bind(this);
        this.warrantyInsertButton = this.warrantyInsertButton.bind(this);
        this.warrantyConfirmDelete = this.warrantyConfirmDelete.bind(this);
        this.warrantyDelete = this.warrantyDelete.bind(this);
        this.tooltipFormatter = this.tooltipFormatter.bind(this);
    }

    componentDidMount() {
        if (this.state.pagingModel.items === null || this.state.pagingModel.items.length === 0) {
            this.props.actions.loadWarranties(this.props.pagingModel).then(() => {
            }).catch(error => {
                notificationPopUp.error('Problemi nel caricamento delle Prestazioni');
            });
        }
        if (!this.state.commonState.configuration || this.state.commonState.configuration.cities === null || this.state.commonState.configuration.cities.length === 0) {
            this.props.commonActions.loadConfiguration().then(() => {
            }).catch(error => {
                notificationPopUp.error('Problemi nel caricamento della configurazione base');
            });
        }
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.authenticationState !== prevState.authenticationState || nextProps.commonState !== prevState.commonState ||
            nextProps.pagingModel !== prevState.pagingModel) {
            const appPaginModel = Object.assign({}, prevState.pagingModel,
                {
                    items: nextProps.pagingModel.items,
                    page: nextProps.pagingModel.page,
                    itemsPerPage: nextProps.pagingModel.itemsPerPage,
                    total: nextProps.pagingModel.total
                });
            return Object.assign({}, prevState, { authenticationState: nextProps.authenticationState, commonState: nextProps.commonState, pagingModel: appPaginModel });
        }
        return null;
    }

    redirectToWarrantyPage() {
        this.props.history.push('warranty');
    }

    updateFilters(event) {
        const state = Object.assign({}, this.state);
        state.pagingModel[event.target.name] = event.target.value;
        this.setState(state);
    }

    search() {
        this.props.actions.loadWarranties(this.state.pagingModel).then(() => {
        }).catch(error => {
            notificationPopUp.error('Problemi nella ricerca');
        });
    }

    onPageChange(page, sizePerPage) {
        var nPaging = Object.assign({}, this.state.pagingModel, { page: page, itemsPerPage: sizePerPage });
        this.props.actions.loadWarranties(nPaging).then(() => {
        }).catch(error => {
            notificationPopUp.error('Problemi nel cambio pagina');
        });
    }

    onSortChange(sortName, sortOrder) {
        var nPaging = Object.assign({}, this.state.pagingModel, { sortName: sortName, sortOrder: sortOrder });
        this.props.actions.loadWarranties(nPaging).then(() => {
        }).catch(error => {
            notificationPopUp.error('Problemi nel sorting');
        });
    }

    gridOnRowClick(row) {
        this.props.history.push('warranty/' + row.id);
    }

    gridCompany(cell, row) {
        for (var i = 0; i < this.props.commonState.configuration.companies.length; i++) {
            if (this.props.commonState.configuration.companies[i].id === cell) {
                return this.props.commonState.configuration.companies[i].name;
            }
        }
        return '---';
    }

    gridActive(cell, row) {
        return (
            <center><CheckboxInput name='' label='' disabled value={cell} /></center>
        );
    }

    warrantyInsertButton() {
        return (<button type="button" className="btn btn-info react-bs-table-add-btn" onClick={this.redirectToWarrantyPage}>
            <span><i className="glyphicon glyphicon-plus"></i>Aggiungi</span>
        </button>);
    }

    warrantyDelete(ids) {
        this.props.actions.deleteWarranty(ids[0]).then(() => {
            notificationPopUp.success('Prestazione Eliminata');
            this.showHideWarrantyDeleteModal([]);
        }).catch(error => {
            notificationPopUp.error(error);
        });
    }

    showHideWarrantyDeleteModal(dropRowKeys) {
        const warrantyDeleteModal = Object.assign({}, this.state.warrantyDeleteModal);
        warrantyDeleteModal.show = !warrantyDeleteModal.show;
        warrantyDeleteModal.dropRowKeysp = dropRowKeys;
        this.setState(Object.assign({}, this.state, { warrantyDeleteModal }));
    }

    warrantyConfirmDelete(next, dropRowKeys) {
        this.showHideWarrantyDeleteModal(dropRowKeys);
    }

    lockedOutFormat(cell, row) {
        if (cell)
            return 'NON MODIFICABILE';
        return 'MODIFICABILE';
    }

    tooltipFormatter(cell, row) {
        return (
            <TooltipFormatter text={cell} tooltip={cell} placement="top" />
        );
    }

    render() {
        const gridOptions = {
            sizePerPage: this.state.pagingModel.itemsPerPage,
            page: this.state.pagingModel.page,
            sizePerPageList: [5, 10, 20, 50],
            onRowClick: this.gridOnRowClick,
            onPageChange: this.onPageChange,
            onSortChange: this.onSortChange,
            insertBtn: this.warrantyInsertButton,
            deleteText: 'Elimina',
            handleConfirmDeleteRow: this.warrantyConfirmDelete,
        };


        return (
            <div className='container-fluid'>
                <h1>Gestione Prestazioni</h1>
                <div className="row panel panel-default x-panel-gray">
                    <div className="panel-heading">Filtri</div>
                    <div className="panel-body">
                        <Row>
                            <Col xs={12} md={3}>
                                <TextInput
                                    label='Nome Compagnia'
                                    name='companyName'
                                    onChange={this.updateFilters}
                                    value={this.state.pagingModel.companyName} />
                            </Col>
                            <Col xs={12} md={3}>
                                <TextInput
                                    label='Nome Prestazione'
                                    name='warrantyName'
                                    onChange={this.updateFilters}
                                    value={this.state.pagingModel.warrantyName} />
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} md={4}>
                                <Button bsStyle='primary' onClick={this.search} >Cerca</Button>
                            </Col>
                        </Row>
                    </div>
                </div>
                <div className="row">
                    <BootstrapTable data={this.state.pagingModel.items} fetchInfo={{ dataTotalSize: this.state.pagingModel.total }}
                        options={gridOptions} insertRow={true} selectRow={{ mode: 'radio' }} deleteRow remote striped hover pagination>
                        <TableHeaderColumn isKey dataField='id' hidden>Id</TableHeaderColumn>
                        <TableHeaderColumn dataField='companyName' width={'20%'} dataSort dataFormat={this.tooltipFormatter}>Nome Compagnia</TableHeaderColumn>
                        <TableHeaderColumn dataField='name' width={'25%'} dataSort dataFormat={this.tooltipFormatter}>Nome</TableHeaderColumn>
                        <TableHeaderColumn dataField='code' width={'10%'} dataSort>Codice</TableHeaderColumn>
                        <TableHeaderColumn dataField='warrantyTypeString' width={'10%'} dataSort>Tipo</TableHeaderColumn>
                        <TableHeaderColumn dataField='companyId' width={'25%'} dataFormat={this.gridCompany} dataSort>Ente</TableHeaderColumn>
                        <TableHeaderColumn dataField='isActive' width={'10%'} dataFormat={this.gridActive} dataSort>Attiva</TableHeaderColumn>
                        <TableHeaderColumn dataField='lockedOut' width={'10%'} dataFormat={this.lockedOutFormat} dataSort>Modificabile</TableHeaderColumn>
                    </BootstrapTable>
                </div>
                <ConfirmationModal
                    title='Conferma Eliminazione Prestazione'
                    message={'Sei sicuro di voler eliminare la Prestazione selezionata?'}
                    show={this.state.warrantyDeleteModal.show}
                    showHide={this.showHideWarrantyDeleteModal}
                    action={() => this.warrantyDelete(this.state.warrantyDeleteModal.dropRowKeysp)}
                    commonState={this.state.commonState} />
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        authenticationState: state.authenticationState,
        commonState: state.commonState,
        pagingModel: state.warrantyState
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(warrantyActions, dispatch),
        commonActions: bindActionCreators(commonActions, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(WarrantiesPage);
